enum SlotInterval {
    none = 0,
    interval_08_12 = 1,
    interval_12_16 = 2,
    interval_16_20 = 3,
}

export default SlotInterval;